import React from 'react';
import { type SVGComponentProps } from '../../../../types/Svgs';

const SVGComponent: React.FC<SVGComponentProps> = ({ primaryColor, secondaryColor, size }) => {
  return (
    <div>
      <svg
        width={size != null ? size[0].toString() : '39'}
        height={size != null ? size[1].toString() : '39'}
        viewBox="0 0 39 39"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <style>
          {`
          .primaryWalking { fill: ${primaryColor != null ? primaryColor : '#4CAF50'} }
          .secondaryWalking { fill: ${secondaryColor != null ? secondaryColor : 'grey'} }
        `}
        </style>
        <circle cx="19.4365" cy="19.4365" r="18.1865" className="primaryWalking" stroke="white" strokeWidth="1.5" />
        <path
          d="M19.5207 12.8637C20.5876 12.8637 21.4525 11.9988 21.4525 10.9318C21.4525 9.86491 20.5876 9 19.5207 9C18.4538 9 17.5889 9.86491 17.5889 10.9318C17.5889 11.9988 18.4538 12.8637 19.5207 12.8637Z"
          fill="white"
        />
        <path
          d="M25.3524 28.4696V28.4692C25.3312 28.3575 23.5501 23.3998 23.5501 23.3998L20.8593 20.6598C20.8593 20.6598 20.8593 16.3615 20.8593 15.0981C20.8593 13.8347 18.5676 13.0096 18.2995 13.1949C18.1236 13.3163 14.0929 15.8181 14.0929 15.8181L13.6654 20.0742C13.6601 20.1135 13.6565 20.1527 13.6565 20.1931C13.6565 20.6734 14.0458 21.0627 14.5261 21.0627C15.0063 21.0627 15.3957 20.6734 15.3957 20.1931L15.7553 16.9519L17.7582 15.7856V20.6437L21.4334 24.1876L23.3091 29.0467C23.4623 29.4479 23.8498 29.7332 24.3046 29.7332C24.8936 29.7332 25.3713 29.2555 25.3713 28.6669C25.3715 28.5993 25.3715 28.5694 25.3524 28.4696Z"
          fill="white"
        />
        <path
          d="M13.255 27.7789C13.0962 27.9652 13 28.2062 13 28.4698C13 29.0586 13.4777 29.5363 14.0665 29.5363C14.4429 29.5363 14.7729 29.3409 14.9628 29.0463L18.2248 24.8266L19.2281 22.6084L17.5785 21.0625L16.3593 23.5505L13.255 27.7789Z"
          fill="white"
        />
        <path
          d="M21.3351 17.2959C21.3351 17.2959 21.3024 19.6915 21.3351 19.6421C21.3637 19.5991 22.5412 20.5763 22.8443 20.8289C22.8665 20.8499 22.8899 20.8692 22.9142 20.8877C22.9147 20.8877 22.9151 20.8881 22.9151 20.8881C23.06 20.997 23.24 21.0619 23.4354 21.0619C23.9152 21.0619 24.3048 20.6725 24.3048 20.1923C24.3048 19.8686 24.1289 19.669 23.8648 19.4371L21.3351 17.2959Z"
          fill="white"
        />
      </svg>
    </div>
  );
};

export default SVGComponent;
